import { CheckCircleIcon, ClockIcon, TruckIcon, XCircleIcon } from 'lucide-react';
import React from 'react';

interface HistoryItem {

id?: number;
waybill: string;
eventdate: string;
eventdescription: string,
eventorder: string
}

interface OrderHistoryProps {
  saveHistory: HistoryItem[];
  
}

const OrderHistorys: React.FC<OrderHistoryProps> = ({ saveHistory}) => {

  const getStatusIcon = (eventdescription: string) => {
    switch (eventdescription) {
      case "order_received":
        return <ClockIcon className="h-6 w-6 text-yellow-500" />;
      case "Processing":
        return <TruckIcon className="h-6 w-6 text-blue-500" />;
      case "Shipped":
        return <CheckCircleIcon className="h-6 w-6 text-green-500" />;
      case "Delivered":
        return <CheckCircleIcon className="h-6 w-6 text-green-700" />;
      case "Cancelled":
        return <XCircleIcon className="h-6 w-6 text-red-500" />;
      case "Failed":
        return <XCircleIcon className="h-6 w-6 text-red-700" />; // You can adjust the color as needed
      case "Accepted":
        return <CheckCircleIcon className="h-6 w-6 text-orange-500" />; // You can adjust the color as needed
      default:
        return null;
    }
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      day: "numeric",
      year: "numeric",
      month: "long",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

    
  return (
    <div>
      <p className="text-[rgb(0,93,110)] text-[20px] mb-[15px] font semi-bold">
        Order History
      </p>
      <div></div>
      <div className=" bg-white p-2 rounded-lg   border border-gray-100 shadow-sm">
        <ul className="space-y-4">
          {saveHistory.map((order) => (
            <li
              key={order.id}
              className="flex items-center justify-between  ">
              <div className="flex items-center space-x-2">
                {getStatusIcon(order.eventdescription)}
                <div>
                  <h3 className="text-lg font-medium">{`Order ID: ${order.waybill}`}</h3>
                  <p className="text-gray-600 capitalize">{`Status: ${order.eventdescription}`}</p>
                </div>
              </div>
              <span className="text-sm text-gray-500">{ formatDate(order.eventdate)}</span>
            </li>
          ))}
        </ul>
      </div>
      
    </div>
  );
};

export default OrderHistorys;
